export default function ContactMap() {
  return (
    <section className="bg-white py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-10 items-stretch">
          {/* Left: Service info */}
          <div className="w-full lg:w-[38%] bg-[#5C5470] rounded-3xl p-10 flex flex-col justify-between">
            <div>
              <p className="text-[#D4A373] font-semibold tracking-widest mb-4" style={{ fontSize: '1rem' }}>
                SERVICE AREA
              </p>
              <h2
                className="font-serif font-bold text-white mb-6"
                style={{ fontSize: 'clamp(1.5rem, 2.5vw, 2.125rem)', lineHeight: '1.4' }}
              >
                服務地區與方式
              </h2>
              <div className="w-14 h-1 bg-[#D4A373] rounded-full mb-8"></div>

              <ul className="space-y-5">
                {[
                  { icon: 'ri-map-pin-line', title: '服務地區', desc: '台灣全區，提供線上視訊與電話諮詢' },
                  { icon: 'ri-video-chat-line', title: '線上諮詢', desc: '視訊會議、電話諮詢，彈性安排時間' },
                  { icon: 'ri-time-line', title: '服務時間', desc: '週一至週五 09:00–18:00' },
                  { icon: 'ri-customer-service-2-line', title: '緊急聯繫', desc: '理賠協助可優先安排，請來電說明' },
                ].map((item) => (
                  <li key={item.title} className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/12 flex-shrink-0 mt-0.5">
                      <i className={`${item.icon} text-[#D4A373] text-lg`}></i>
                    </div>
                    <div>
                      <p className="font-semibold text-white" style={{ fontSize: '1.0625rem' }}>{item.title}</p>
                      <p className="text-white/65 mt-0.5" style={{ fontSize: '1rem', lineHeight: '1.6' }}>{item.desc}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-10 pt-8 border-t border-white/15">
              <p className="text-white/50" style={{ fontSize: '1rem', lineHeight: '1.7' }}>
                保險建築師提供全台線上諮詢服務，無論您在哪個縣市，都能透過視訊或電話獲得專業的保障規劃建議。
              </p>
            </div>
          </div>

          {/* Right: Map placeholder */}
          <div className="w-full lg:w-[62%] rounded-3xl overflow-hidden min-h-[420px] relative bg-[#F8F5F0] border border-gray-100 flex flex-col items-center justify-center">
            <img
              src="https://readdy.ai/api/search-image?query=Taiwan%20island%20map%20aerial%20view%20clean%20minimal%20professional%20cartography%20soft%20colors%20geographic%20overview&width=800&height=500&seq=mapbg001&orientation=landscape"
              alt="台灣服務地區示意圖"
              className="absolute inset-0 w-full h-full object-cover object-center opacity-30"
            />
            <div className="relative z-10 text-center px-8">
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#D4A373]/20 mx-auto mb-5">
                <i className="ri-map-pin-2-line text-[#D4A373] text-3xl"></i>
              </div>
              <h3
                className="font-serif font-bold text-[#5C5470] mb-3"
                style={{ fontSize: 'clamp(1.25rem, 2vw, 1.625rem)', lineHeight: '1.45' }}
              >
                台灣全區線上服務
              </h3>
              <p className="text-gray-600 max-w-sm mx-auto" style={{ fontSize: '1.0625rem', lineHeight: '1.75' }}>
                不受地域限制，透過視訊或電話，隨時為您提供專業的保障規劃諮詢。
              </p>
              <div className="mt-6 flex flex-wrap gap-3 justify-center">
                {['台北', '新北', '桃園', '台中', '台南', '高雄', '其他縣市'].map((city) => (
                  <span
                    key={city}
                    className="bg-white border border-[#D4A373]/30 text-[#5C5470] px-3 py-1.5 rounded-full font-medium"
                    style={{ fontSize: '1rem' }}
                  >
                    {city}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
